var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.16797 22.1667C1.16797 23.0417 1.41297 23.87 1.84464 24.57C2.64964 25.9233 4.1313 26.8333 5.83464 26.8333C7.53797 26.8333 9.01964 25.9233 9.82464 24.57C10.2563 23.87 10.5013 23.0417 10.5013 22.1667C10.5013 19.5883 8.41297 17.5 5.83464 17.5C3.2563 17.5 1.16797 19.5883 1.16797 22.1667Z",
    fill: "#FBA12B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4801 23.8159L4.18359 20.5195M4.1838 23.8159L7.48031 20.5195",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33463 9.33151C2.33463 9.97318 2.85963 10.4982 3.5013 10.4982H24.5013C25.143 10.4982 25.668 9.97318 25.668 9.33151V8.79484C25.668 6.12318 23.5096 3.96484 20.838 3.96484H7.1763C4.50463 3.96484 2.33463 6.13484 2.33463 8.80651V9.33151Z",
    fill: "#FBA12B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.668 19.1994C25.668 21.871 23.5096 24.0294 20.838 24.0294H13.5346C12.858 24.0294 12.2746 23.4577 12.333 22.781C12.4963 20.996 11.9246 19.0594 10.338 17.5194C9.68463 16.8777 8.87963 16.3877 8.00463 16.1077C6.5463 15.641 5.13463 15.6994 3.8863 16.1194C3.12797 16.376 2.33463 15.8277 2.33463 15.0227V13.401C2.33463 12.7594 2.85963 12.2344 3.5013 12.2344H24.5013C25.143 12.246 25.668 12.771 25.668 13.4127V19.1994ZM21.0013 20.121C21.4796 20.121 21.8763 19.7244 21.8763 19.246C21.8763 18.7677 21.4796 18.371 21.0013 18.371H18.668C18.1896 18.371 17.793 18.7677 17.793 19.246C17.793 19.7244 18.1896 20.121 18.668 20.121H21.0013Z",
    fill: "#FBA12B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCard);
export default __webpack_public_path__ + "static/media/Delete-card.1d0383e1d9335684dd61d137583ce292.svg";
export { ForwardRef as ReactComponent };